import { Component } from '@angular/core';
import { NavController, NavParams, PopoverController, LoadingController, ViewController } from 'ionic-angular';

import { CoBookScannerPopoverComponent } from '../../components/co-book-scanner-popover/co-book-scanner-popover';
import { IlsProvider } from '../../providers/ils/ils';
import moment from 'moment';
import { PatronProvider } from '../../providers/patron/patron';
import { CoCheckoutConfirmPage } from '../co-checkout-confirm/co-checkout-confirm';
// import { CoPopoverKeyboardComponent } from '../../components/co-popover-keyboard/co-popover-keyboard';
import { ConfigProvider } from '../../providers/config/config';
import { AppState } from '../../config/state';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
/**
 * Generated class for the CheckinPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-checkin',
  templateUrl: 'checkin.html',
})
export class CheckinPage {
 scanInfo: any;
  bookList: any = [];
  patron: any;
  patronLoggedIn: boolean = false;
  returnDate: string = moment().add(1, 'month').format("YYYY-MM-DD HH:mm:ss");
  isForApp: boolean;
  isbnObj: any = {};
  viewType: any;
  menuSide: string = "left";

  constructor(public navCtrl: NavController, public navParams: NavParams, public toast: ToastAlertsProvider, public popoverCtrl: PopoverController, public ilsProdiver: IlsProvider, public patronProvider: PatronProvider, public state: AppState, public config: ConfigProvider, public loading:LoadingController, private viewCtrl : ViewController) {
    this.isForApp = this.state.cordovaAvailable;

    this.viewType = this.state.mode;
    this.state.burgerMenu && this.state.burgerMenu.menuSide ? this.menuSide = this.state.burgerMenu.menuSide : this.menuSide = "hidden";
  }

  // ionViewDidLoad() {
  //   if (!this.bookList || this.bookList.length <= 0) {

  //   }
  // }

  // scanAnotherBook() {

  // }

  // async getBookInformation(info) {
  //   const res  = await this.ilsProdiver.getBibDetailsFromId(info);
  //   if (res){

  //   let isbn = res.isbns[0].split(' ')[0];
  //     if (isbn.length === 10 || isbn.length === 13){
  //       this.isbnObj[res.id] = {number: isbn, type: 'isbn'};
  //     } else {
  //       this.isbnObj[res.id] = {number: isbn, type: 'upc'}
  //     }
  //       res.barcode = info
  //       this.bookList.push(res);
  //   }else{
  //       this.triggerToast(`Sorry, we could not find this book, please enter again`);
  //     }
  // }

  // triggerToast(msg) {
  //   this.toast.triggerToast(msg, '');
  // }

  // removeBook(bookTag) {
  //   let bookIndex = 0;
  //   this.bookList.forEach((book, i) => {
  //     if (book.barcode === bookTag) {
  //       bookIndex = i;
  //     }
  //   });
  //   this.bookList.splice(bookIndex, 1);
  // }

  // goToNext(){
  //   if (this.bookList.length > 0) {
  //     this.config.load(this.state.appId).then(cfg => {
  //       this.navCtrl.push(CoCheckoutConfirmPage, { page: 'checkin', books: this.bookList });
  //     });
  //   } else {
  //     this.triggerToast('Please enter a book!');
  //   }
  // }

}



// WEBPACK FOOTER //
// ./src/pages/checkin/checkin.ts